/* v8 ignore start */
import RollbarLibrary, {LogArgument} from "rollbar";

import {FunctionUtils} from "@/lib/utils/functionUtils";
import {ObjectUtils} from "@/lib/utils/objectUtils";

export class Rollbar {
  public readonly client?: RollbarLibrary;

  public constructor(rollbarClient?: RollbarLibrary) {
    ObjectUtils.bindOwnProperties(this);

    this.client = rollbarClient;
  }

  public error(...args: LogArgument[]): void {
    console.error(args); // eslint-disable-line no-console

    if (this.client?.options.environment === "development" || this.client?.options.environment === "ci") {
      return;
    }

    this.withClient((client) => client.error(...args));
  }

  private withClient(fn: FunctionUtils.TCallback<RollbarLibrary>): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.client && fn(this.client);
  }
}
/* v8 ignore stop */
